import { parseJwt, validateToken } from '../utils';
import { CoreEntities } from './permissions';

export const MUTATIONS_MAP = {
    CREATE_GUEST_ACCESS_STATE: 'CREATE_GUEST_ACCESS_STATE',
    CLEAR_GUEST_ACCESS_STATE: 'CLEAR_GUEST_ACCESS_STATE',
};

const state = {
    guestToken: '',
    refreshToken: '',
    comebackUrl: '',
    parsedJwt: {},
};

const getters = {
    isGuestAccess(state) {
        return Boolean(state.guestToken && state.refreshToken);
    },
    actions(state) {
        return state.parsedJwt.actions || {};
    },
    roles(state) {
        return state.parsedJwt.roles || [];
    },
    // @TODO make single permission check methods when we move editor
    // to action system, until then let it be separate
    // same for groups
    guestAccessActionPermission: (state, getters) => (resource, action) => {
        if (!getters.actions[resource]) {
            return false;
        }

        let actions = getters.actions[resource];

        if (!Array.isArray(actions)) {
            actions = CoreEntities.getActions(resource).getActions(actions);
        }

        return actions.includes(action);
    },
    isInGroup: (_, getters) => (group) => {
        return getters.roles.includes(group);
    },
    customerId(state) {
        return state.parsedJwt.customer_id;
    },
};

const mutations = {
    CREATE_GUEST_ACCESS_STATE(state, { token, refreshToken, comebackUrl = null }) {
        state.guestToken = token;
        state.refreshToken = refreshToken;

        state.parsedJwt = parseJwt(token);

        if (comebackUrl) {
            state.comebackUrl = comebackUrl;
        }
    },
    CLEAR_GUEST_ACCESS_STATE(state) {
        state.guestToken = '';
        state.refreshToken = '';
        state.comebackUrl = '';
        state.parsedJwt = {};
    },
};

const actions = {
    createGuestAccessState({ commit }, payload) {
        if (!payload.token || !payload.refreshToken) {
            throw new Error('Guest Access: no token or refresh token provided');
        }

        const validatedToken = validateToken(payload.token);

        if (!validatedToken) {
            commit('INVALID_TOKEN', {}, { root: true });
            return;
        }

        commit(MUTATIONS_MAP.CREATE_GUEST_ACCESS_STATE, {
            ...validatedToken,
            ...payload,
        });
    },
    clearGuestAccessState({ commit }) {
        commit(MUTATIONS_MAP.CLEAR_GUEST_ACCESS_STATE);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
